import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { useRouteError } from 'react-router';
import ErrorFallBack from '../ErrorFallBack/index.tsx';

export const ErrorBoundary = () => {
  const error = useRouteError();

  useEffect(() => {
    if (error) {
      Sentry.captureException(error);
    }
  }, [error]);

  return <ErrorFallBack />;
};
